/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { blogService } from './services';

// #endregion Local Imports

const pathname = '/blog-entity-posts';

export const EntityBlogApi = {
  filter: async (option: FilterEntityBlogOptions) => {
    let url = `${pathname}/filter`;
    const query = serialize(option);
    url += query;

    try {
      const response = await blogService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (body: any) => {
    try {
      const response = await blogService.post(pathname, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findOne: async (id: string) => {
    const url = `${pathname}/entity/${id}`;
    try {
      const response = await blogService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await blogService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  remove: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await blogService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface FilterEntityBlogOptions {
  page?: number;
  take?: number;
  order?: any;
  reserved?: boolean;
  name?: string;
  provinceID?: string;
  entityID?: string;
  status?: number;
}
